/**
 * @Author: v_jppjpeng
 * @Date: 2023-03-20 10:53:48
 * @Explain: 公共配置（默认语言，文件大小限制，字数大小限制 等）
 */
import type {
  AbbreviationLanguageType,
  LanguageType,
} from '@/definition/common/data.d';
import {
  AbbreviationLanguageEnum,
  LanguageEnum,
} from '@/definition/common/data.d';

/** 是否启用MOCK */
export const IS_MOCK = false;

/** 默认语言 */
export const DEFAULT_LANGUAGE: LanguageType = LanguageEnum.EN;
export const DEFAULT_ABBREVIATION_LANGUAGE: AbbreviationLanguageType =
  AbbreviationLanguageEnum.EN;

/** 客服邮箱  */
export const CUSTOMER_SERVICE_EMAIL = 'SmartLink_service@proximabeta.com';

/** 登录、注册 */
// 邮箱 - 最长100个字符
export const ADMIN_EMAIL_MAX_LEN = 100;
// 用户名 - 最长100个字符
export const ADMIN_ACCOUNT_NAME_MAX_LEN = 100;
// 密码 - 最长50个字符
export const ADMIN_PASSWORD_MAX_LEN = 50;
// 双因素验证码 - 最大位数
export const TWO_FACTOR_CODE_MAX_LEN = 6;

// 上传文件 - 最大数量1个
export const MAX_UPLOAD_FILE_NUM = 1;
// 上传文件 - 类型CSV
export const UPLOAD_FILE_TYPE_CSV = 'text/csv';

/** 活动管理 - 创建活动 - 活动名称 */
export const ACTIVITY_MANAGE_NAME_MAX_LENGTH = 50;
/** 创建活动、发送测试邮件 - 主题名称 - 文字最大长度 */
export const SUBJECT_NAME_NAME_MAX_LENGTH = 256;
export const SUBJECT_NAME_MAX_LENGTH = 256;
/** 创建活动、发送测试邮件 - 预览文本 - 文字最大长度 */
export const PREVIEW_TEXT_MAX_LENGTH = 200;
/** 创建活动、发送测试邮件 -回复邮箱 - 文字最大长度 */
export const CONTACT_EMAIL_MAX_LENGTH = 100;
/** 创建活动 - 活动目的 - 文字最大长度 */
export const ACTIVITY_PURPOSE_MAX_LENGTH = 50;

/** A/B 测试 - 实验组 - 最小数量 */
export const AB_TEST_EXPERIMENTAL_GROUP_MIN_LEN = 2;
/** A/B 测试 - 实验组 - 最大数量 */
export const AB_TEST_EXPERIMENTAL_GROUP_MAX_LEN = 5;
/** A/B 测试 - 实验组 - 单组最大人数 */
export const AB_TEST_EXPERIMENTAL_GROUP_MAX_NUMBER_PEOPLE = 6000;

/** 活动管理 - 自动化活动 - 旅程名称 */
export const ACTIVITY_AUTO_JOURNEY_NAME_MAX_LENGTH = 50;

/** 联系人管理 -  上传联系人 - excel上传动态变量 - 最大文件大小 */
/** 文案限制20M，实际允许25M */
export const CONTACT_MANAGE_EXCEL_MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

/** 联系人管理 -  上传联系人 - excel上传动态变量 - 最大文件名称长度 */
export const CONTACT_MANAGE_EXCEL_MAX_NAME_LENGTH = 255;

/** 联系人管理 -  上传联系人 - 详情 excel上传文件内Tag最大个数限制 */
export const CONTACT_MANAGE_EXCEL_MAX_TAG_NUM_THOUSAND = 1000;
/** 联系人管理 -  上传联系人 - 新增 excel上传文件内Tag最大个数限制 */
export const CONTACT_MANAGE_EXCEL_MAX_TAG_NUM_TEN = 20;
/** 联系人管理 - 绑定标签最多20个 */
export const CONTACT_MANAGE_TAGS_LIMIT_NUM = 20;
/** 联系人管理 - 设置预约 弹窗最大添发送测试email个数 */
export const CONTACT_MANAGE_MAX_SEND_EMAIL_NUM = 50;

/** 联系人管理 - 列表 - 批量删除最大值 */
export const CONTACT_MANAGE_LIST_DEL_MAX_LEN = 100000;

/** 联系人管理 - 字段设置 - 名称 */
export const CONTACT_MANAGE_FIELD_NAME_MAX_LEN = 50;

/** 联系人管理 - 字段设置 - 选项名称 */
export const CONTACT_MANAGE_FIELD_OPTION_NAME_MAX_LEN = 50;
/** 联系人管理 - 字段设置 - 选项个数 */
export const CONTACT_MANAGE_FIELD_OPTION_NAME_MAX_NUM = 50;

/** 联系人管理 - opt-in 设置 - 主题 */
export const CONTACT_MANAGE_OPT_IN_SUBJECT_MAX_LEN = 40;
/** 联系人管理 - opt-in 设置 - 联系人邮箱 */
export const CONTACT_MANAGE_OPT_IN_CONTACT_EMAIL_MAX_LEN = 250;

/** 联系人管理 - 注册表单 - 标题名称最大长度 */
export const CONTACT_MANAGE_SIGN_UP_FORM_NAME_MAX_LEN = 50;
/** 联系人管理 - 注册表单 - 自定义字段初始显示条数 */
export const CONTACT_MANAGE_SIGN_UP_FORM_INIT_ATTRIBUTES_MAX_NUM = 10;

/** 分层规则 - 创建分层 - 分层名称 */
export const SEGMENTS_MANAGE_NAME_MAX_LENGTH = 50;
/** 分层规则 - 创建分层 - 分层条件 - 最大条数 */
export const SEGMENTS_MANAGE_CONDITION_MAX_NUMBER = 5;

/** 标签管理 - 创建标签 - 名称 - 最大字数 */
export const TAG_MANAGE_NAME_MAX_NUMBER_WORDS = 100;

/** 偏好管理 - 选项 - 最大数量  */
export const PREFERENCE_MANAGE_OPTION_MAX_NUM = 20;
/** 偏好管理 - 选项 - 名称最大字数  */
export const PREFERENCE_MANAGE_OPTION_NAME_MAX_NUMBER_WORDS = 100;
/** 偏好管理 - 选项 - 描述最大字数  */
export const PREFERENCE_MANAGE_OPTION_DESC_MAX_NUMBER_WORDS = 600;

/** 模板管理 - 创建模板 - 标题最大字数 */
export const TEMPLATE_MANAGE_CREATE_TITLE_MAX_LEN = 50;

/** 占位符 - 名称最大字数 */
export const PLACEHOLDER_NAME_MAX_LEN = 80;
/** 占位符 - 资源码兑换内容ID最大长度 */
export const PLACEHOLDER_KEY_CONTENT_ID_MAX_LEN = 100;
/** 占位符 - 资源码描述最大长度 */
export const PLACEHOLDER_DISTRIBUTION_MAX_LEN = 200;
/** 占位符 - 创建占位符 - 上传动态变量 - 文件单元格内容限制最大长度 */
export const PLACEHOLDER_DYNAMIC_MAX_FILE_CELL_LENGTH = 255;
/** 占位符 - CSV导入文件限制20M */
export const PLACEHOLDER_CSV_FILE_MAX_SIZE = 20 * 1024 * 1024; // 20MB
/** 消息推送 - JSON文件限制1M */
export const JSON_FILE_MAX_SIZE = 1 * 1024 * 1024; // 1MB
/** 消息推送 - 推送实验 - 推送标题最大字数（与后端 check_json 校验一致） */
export const PUSH_EXPERIMENT_TITLE_MAX_LENGTH = 65;
/** 消息推送 - 推送实验 - 推送正文最大字数（与后端 check_json 校验一致） */
export const PUSH_EXPERIMENT_BODY_MAX_LENGTH = 240;
/** 消息推送 - 推送实验 - 校验错误列表最多展示条数（超出折叠为 …） */
export const PUSH_EXPERIMENT_ERROR_MAX_ITEMS = 10;

/** 设置管理 - 发件人 名称最大字数 */
export const SENDER_NAME_MAX_LEN = 100;
/** 设置管理 - 发件人 备注最大字数 */
export const SENDER_NAME_REMARK_MAX_LEN = 50;

/** 设置管理 - 发件地址 名称最大字数 */
export const SENDER_ADDRESS_NAME_MAX_LEN = 90;
/** 设置管理 - 发件地址 备注最大字数 */
export const SENDER_ADDRESS_REMARK_MAX_LEN = 50;

/** 设置管理 - API-Key 名称最大字数 */
export const API_KEY_NAME_MAX_LEN = 50;
/** 设置管理 - API-Key 备注最大字数 */
export const API_KEY_REMARK_MAX_LEN = 200;

/** 设置管理 - webhook - 最大添加数量 */
export const WEB_HOOK_ADD_MAX_LEN = 10;
/** 设置管理 - webhook - 链接最大长度 */
export const WEB_HOOK_URL_MAX_LEN = 1000;
/** 设置管理 - webhook - 备注最大字数 */
export const WEB_HOOK_DESC_MAX_LEN = 1000;

/** 设置管理 - 拒绝列表 弹窗最大添加到拒绝列表email个数 */
export const REJECT_MAX_REJECT_EMAIL_NUM = 1000;

/** 设置管理 - 拒绝列表 CSV导入文件限制20M */
export const REJECT_MAX_CSV_MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB

/** 联系人报表 - 过滤名称 - 最大长度 */
export const CONTACT_REPORT_FILTER_NAME_MAX_LEN = 50;
/** 联系人报表 - My filter - 最大数量 */
export const CONTACT_REPORT_MY_FILTER_MAX_NUM = 10;

/** 活动报表 - 创建分组 - 分组名称最大字数 */
export const ACTIVITY_REPORT_CREATE_GROUP_NAME_MAX_LEN = 50;
/** 活动报表 - 创建分组 - 分组内活动最大个数 */
export const ACTIVITY_REPORT_CREATE_GROUP_ACTIVITY_MAX_NUM = 30;

/** 营销型模板 - 上传文件 - 最大文件大小 */
export const MARKETING_SET_UPLOAD_MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

/** 营销型模板 - 上传文件 - 超时时间 1分钟 */
export const MARKETING_SET_UPLOAD_TIME_OUT = 60 * 1000; // 60000ms

/** 大区管理 - 新增-修改大区 - whatsApp模板名称 - 名称最大字数  */
export const AREA_MANAGE_ADD_EDIT_NAME_MAX_LEN = 60;

/** 测试人创建-弹窗 名字-最大字数 **/
export const TESTER_MANAGE_ADD_EDIT_NAME_MAX_LEN = 60;
/** 测试人创建-弹窗 描述 最大字数 **/
export const TESTER_MANAGE_ADD_EDIT_DESCRIPTION_MAX_LEN = 200;

/** 账号中心 - API-Key 名称最大字数 */
export const ACCOUNT_CENTER_API_KEY_NAME_MAX_LEN = 64;
/** 账号中心 - API-Key 最大条数 */
export const ACCOUNT_CENTER_API_KEY_MAX_NUM = 10;
